import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper.min.css';
import 'swiper/css/pagination'; // 轮播图底面的小圆点
import { Pagination, Autoplay } from 'swiper';
import { defineComponent, ref } from 'vue';
export default defineComponent({
  components: {
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = swiper => {
      console.log('swiper', swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    let pagination = {
      el: '.swiper-pagination',
      type: 'bullets'
    };
    let autoplay = {
      autoplay: false,
      delay: 3000
    };
    const modules = [Pagination, Autoplay];
    // 模块class内容
    let moduleClass1 = ref('module active');
    let moduleClass2 = ref('module modul2');
    let moduleClass3 = ref('module modul3');
    let moduleClass4 = ref('module modul4');
    let moduleClass5 = ref('module modul5');
    let active = ref(1);
    let noActive = ref(0);
    const changeM = num => {
      noActive.value = active.value;
      if (noActive.value == 1) {
        moduleClass1.value = 'module noActive';
      } else if (noActive.value == 2) {
        moduleClass2.value = 'module modul2 noActive';
      } else if (noActive.value == 3) {
        moduleClass3.value = 'module modul3 noActive';
      } else if (noActive.value == 4) {
        moduleClass4.value = 'module modul4 noActive';
      } else if (noActive.value == 5) {
        moduleClass5.value = 'module modul5 noActive';
      }
      active.value = num;
      if (active.value == 1) {
        moduleClass1.value = 'module active';
      } else if (active.value == 2) {
        moduleClass2.value = 'module modul2 active';
      } else if (active.value == 3) {
        moduleClass3.value = 'module modul3 active';
      } else if (active.value == 4) {
        moduleClass4.value = 'module modul4 active';
      } else if (active.value == 5) {
        moduleClass5.value = 'module modul5 active';
      }
    };
    let pageActive = ref(false);
    return {
      pageActive,
      modules,
      onSwiper,
      onSlideChange,
      pagination,
      autoplay,
      moduleClass1,
      moduleClass2,
      moduleClass3,
      moduleClass4,
      moduleClass5,
      active,
      changeM
    };
  }
});